import { saveOrUpdate, getRuleById } from '../../../services/services';
import { getSelectWeeks, getFixationRuleVOTimeArr } from '../../../utils/studentAttendance';

const initState = {
  checkRuleType: 2, // 1，每日灵活，2，统一时间
  selectWeekDay: [], //  固定or灵活考勤时间已选星期
  fixationRuleVO: {
    fixationCalculateRuleId: 3, // 计算规则id，2：进校判定，1：进出校判定， 3：表示就寝规则
    fixationCheckTime: '', // 固定进出校判定规则:07:00,09:00,11:00,12:00;13:00,14:00,17:00,18:00
    fixationCheckWeek: '', // 1,2,3,4,5      选择的星期，逗号隔开
  },
  fixationRuleVOTimeArr: [], // 固定考勤时间数组
  showRegularTimeTable: false, // 是否显示设置固定考勤时段弹框
  nocheckDateModal: false, // 是否显示设置无需考勤弹框
  checkNewRuleNocheckDate: [], // 无需考勤时间
  specialTimeModal: false, // 是否显示设置特殊考勤弹框
  checkNewRuleSpecialDate: [], // 特殊考勤时间
  specialRuleVOTimeArr: [], // 特殊考勤时间数组
  specialCurrentDateStart: '', // 特殊考勤当前开始时间
  specialCurrentDateEnd: '', // 特殊考勤当前结束时间
};

export default {
  namespace: 'dateAndTimeDorm',
  state: initState,
  effects: {
    *fetchSaveOrUpdate({ params }, { call }) {
      try {
        const response = yield call(saveOrUpdate, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchRuleById({ params }, { call, put }) {
      try {
        const response = yield call(getRuleById, params);
        const fixationRuleVO = {
          fixationCalculateRuleId: 3, // 计算规则id，2：进校判定，1：进出校判定
          fixationCheckTime: '', // 固定进出校判定规则:07:00,09:00,11:00,12:00;13:00,14:00,17:00,18:00
          fixationCheckWeek: '', // 1,2,3,4,5      选择的星期，逗号隔开
        };

        yield put({
          type: 'saveState',
          payload: {
            checkRuleType: 2,
            checkNewRuleNocheckDate: response.checkNewRuleNocheckDate || [],
            checkNewRuleSpecialDate: response.checkNewRuleSpecialDate || [],
            fixationRuleVO: response.fixationRuleVO.fixationCheckTime
              ? response.fixationRuleVO
              : fixationRuleVO,
            selectWeekDay: getSelectWeeks(response) || [],
            fixationRuleVOTimeArr: getFixationRuleVOTimeArr(response),
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
